import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        const elements = document.querySelectorAll(".fadeInUp, .mainVisual, .bgColor, .slideIn, .slideInL");

        // 👇 挙動ごとに分ける
        const onceClasses = ["fadeInUp", "mainVisual"]; // 一度だけ
        const toggleClasses = ["bgColor", "slideIn", "slideInL"]; // 出入りでON/OFF

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const el = entry.target;

                    const hasClass = (classList) =>
                        classList.some((cls) => el.classList.contains(cls));

                    if (entry.isIntersecting) {
                        el.classList.add("on");

                        // 一度だけ発火
                        if (hasClass(onceClasses)) {
                            observer.unobserve(el);
                        }
                    } else {
                        // 出たら外す
                        if (hasClass(toggleClasses)) {
                            el.classList.remove("on");
                        }
                    }
                });
            },
            { threshold: 0.1 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }
};

export const onClientEntry = () => {
    if (typeof document !== "undefined") {
        document.documentElement.classList.add("js");
    }
};
